import { RootState } from 'store';

export const categoryData = (state: RootState) => state.categoryDate;
